import "./Hero.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaSearch,
  FaMapMarkerAlt,
  FaThLarge,
  FaImage,
  FaUtensils,
  FaMusic,
  FaHotel,
  FaShoppingCart,
  FaCamera,
  FaGlobe,
  FaClock,
  FaGift,
  FaBookmark,
  FaChevronDown,
  FaChevronRight,
  FaHammer,
  FaPaintRoller,
  FaBolt,
  FaWrench,
  
} from "react-icons/fa";



function Hero() {
  const navigate = useNavigate();

   const [keyword, setKeyword] = useState("");
   const [location, setLocation] = useState("");
   const [category, setCategory] = useState("");
   const [showLocation, setShowLocation] = useState(false);
   const [showMohali, setShowMohali] = useState(false);
   const handleSearch = () => {

  navigate(
  `/search-results?location=${location}&category=${category}`
);

};
  return (
    <>
      {/* ================= HERO SECTION ================= */}

      <section
        className="cc-home-hero"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1565953522043-baea26b83b7e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmVhbGVzdGF0ZSUyMGltYWdlJTIwYmFja2dyb3VuZHxlbnwwfHwwfHx8MA%3D%3D)",
        }}
      >
        <div className="cc-home-overlay">
          <div className="cc-home-content">
            <h1 className="cc-home-title">
              Find the Best Places to Be
            </h1>

            <p className="cc-home-subtitle">
              All the top locations – from restaurants and clubs,
              to cinemas, galleries, and more.
            </p>

            {/* Search */}

            <div className="cc-home-search">

  <div className="cc-home-input-box">
    <FaThLarge className="cc-home-input-icon" />

    <select
      value={category}
      onChange={(e) => setCategory(e.target.value)}
    >
      <option value="">All Categories</option>
      <option value="Interior Designers">Interior Designers</option>
      <option value="Carpenters">Carpenters</option>
      <option value="Electricians">Electricians</option>
      <option value="Plumbers">Plumbers</option>
      <option value="Tile Contractors">Tile Contractors</option>
    </select>
  </div>

  

  <div className="cc-home-input-box custom-location">

    <FaMapMarkerAlt className="cc-home-input-icon" />

    <div
        className="location-select"
        onClick={() => setShowLocation(!showLocation)}
    >

        <span>{location || "All Locations"}</span>

        <FaChevronDown className="down-icon" />

    </div>

    {showLocation && (

        <div className="location-dropdown">

          {/* Kanpur */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Kanpur");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Kanpur</span>
            </div>

            {/* Lucknow */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Lucknow");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Lucknow</span>
            </div>

            {/* Bhopal */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Bhopal");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Bhopal</span>
            </div>

            {/* Chandigarh */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Chandigarh");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Chandigarh</span>
            </div>

            {/* Mohali */}

            <div className="location-option has-sub">

                <div
                    className="location-row"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowMohali(!showMohali);
                    }}
                >

                    <span>Mohali</span>

                    {showMohali ? (
                        <FaChevronDown />
                    ) : (
                        <FaChevronRight />
                    )}

                </div>

                {showMohali && (

                    <div className="location-submenu">

                        <div
                            onClick={() => {
                                setLocation("Phase 5");
                                setShowMohali(false);
                                setShowLocation(false);
                            }}
                        >
                            Phase 5
                        </div>

                        <div
                            onClick={() => {
                                setLocation("Phase 7");
                                setShowMohali(false);
                                setShowLocation(false);
                            }}
                        >
                            Phase 7
                        </div>

                        <div
                            onClick={() => {
                                setLocation("Phase 11");
                                setShowMohali(false);
                                setShowLocation(false);
                            }}
                        >
                            Phase 11
                        </div>

                        <div
                            onClick={() => {
                                setLocation("Sector 70");
                                setShowMohali(false);
                                setShowLocation(false);
                            }}
                        >
                            Sector 70
                        </div>

                        <div
                            onClick={() => {
                                setLocation("Kharar");
                                setShowMohali(false);
                                setShowLocation(false);
                            }}
                        >
                            Kharar
                        </div>

                    </div>

                )}

            </div>

            {/* Panchkula */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Panchkula");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Panchkula</span>
            </div>

            {/* Baltana */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Baltana");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Baltana</span>
            </div>

            {/* Zirakpur */}

            <div
                className="location-option"
                onClick={() => {
                    setLocation("Zirakpur");
                    setShowLocation(false);
                    setShowMohali(false);
                }}
            >
                <span>Zirakpur</span>
            </div>

        </div>

    )}

</div>

  
  <button
    className="cc-home-search-btn"
    onClick={handleSearch}
  >
    SEARCH PLACES
  </button>

</div>

            {/* Categories */}

            {/* Categories */}

<div className="cc-home-categories">

  <div className="cc-home-category">
    <div className="cc-home-circle">
      <FaHammer />
    </div>

    <span>Carpenter Contractor</span>
  </div>

  <div className="cc-home-category">
    <div className="cc-home-circle">
      <FaPaintRoller />
    </div>

    <span>Interior Designer</span>
  </div>

  <div className="cc-home-category">
    <div className="cc-home-circle">
      <FaBolt />
    </div>

    <span>Electrician</span>
  </div>

  <div className="cc-home-category">
    <div className="cc-home-circle">
      <FaWrench />
    </div>

    <span>Plumber</span>
  </div>

  <div className="cc-home-category">
    <div className="cc-home-circle">
      <FaThLarge />
    </div>

    <span>Tile Contractor</span>
  </div>

</div>
          </div>
        </div>
      </section>

      {/* ================= YOUTUBE SECTION ================= */}

<section className="cc-home-youtube-section">
  <div className="cc-home-youtube-heading">
    <h2>Our Latest Videos</h2>

    <div className="cc-home-youtube-divider">
      <span></span>
      <FaCamera className="cc-home-youtube-icon" />
      <span></span>
    </div>

    <p>
      Explore our latest interior projects and work updates.
    </p>
  </div>

  <div className="cc-home-video-grid">

    <iframe
      src="https://www.youtube.com/embed/tpkZ9HSqTmM"
      title="Video 1"
      allowFullScreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/JDLJh5iices"
      title="Video 2"
      allowFullScreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/2mGM7IGgz7g"
      title="Video 3"
      allowFullScreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/BA04Wmu99zI"
      title="Video 4"
      allowFullScreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/R3OEJxDpZyY"
      title="Video 5"
      allowFullScreen
    ></iframe>

    <iframe
      src="https://www.youtube.com/embed/nJ-FhQWsIm0"
      title="Video 6"
      allowFullScreen
    ></iframe>

  </div>
</section>

{/* ===========================
      SPECIAL OFFERS
=========================== */}

<section
  className="cc-home-offer-section"
  style={{
    backgroundImage:
      "url('https://images.unsplash.com/photo-1649770638609-4a938b9f648a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjF8fHJlYWxlc3RhdGUlMjBpbWFnZSUyMGJhY2tncm91bmR8ZW58MHx8MHx8fDA%3D')",
  }}
>
  <div className="cc-home-offer-overlay">

    <div className="cc-home-offer-content">

      <h2>Special Offers Every Day</h2>

      <p>
        Discover exclusive deals from top-rated professionals, restaurants,
        salons, photographers and local businesses. Save more with verified
        offers available every day.
      </p>

      <div className="cc-home-offer-btns">

        <button className="cc-home-offer-btn">
          SEE MORE
        </button>

        <button className="cc-home-offer-btn cc-home-offer-btn2">
          GO NOW
        </button>

      </div>

    </div>

  </div>

</section>

{/* ===========================
      WHY CHOOSE US
=========================== */}

<section className="cc-home-feature-section">

  <div className="cc-home-feature-grid">

    {/* Item 1 */}

    <div className="cc-home-feature-item">

      <div className="cc-home-feature-icon">
        <FaMapMarkerAlt />
      </div>

      <div className="cc-home-feature-content">

        <h3>Available All the Time and Everywhere</h3>

        <p>
          Find trusted professionals anytime, anywhere with
          verified profiles and quality services near you.
        </p>

      </div>

    </div>

    {/* Item 2 */}

    <div className="cc-home-feature-item">

      <div className="cc-home-feature-icon">
        <FaGlobe />
      </div>

      <div className="cc-home-feature-content">

        <h3>Thousands of Places Around the World</h3>

        <p>
          Explore businesses, artisans and experts from
          different cities with ease.
        </p>

      </div>

    </div>

    {/* Item 3 */}

    <div className="cc-home-feature-item">

      <div className="cc-home-feature-icon">
        <FaClock />
      </div>

      <div className="cc-home-feature-content">

        <h3>Quick and Easy Way to Search</h3>

        <p>
          Search instantly using categories, locations
          and advanced filters.
        </p>

      </div>

    </div>

    {/* Item 4 */}

    <div className="cc-home-feature-item">

      <div className="cc-home-feature-icon">
        <FaBookmark />
      </div>

      <div className="cc-home-feature-content">

        <h3>Tons of Great Offers Every Day</h3>

        <p>
          Enjoy exclusive discounts and special offers
          from verified professionals every day.
        </p>

      </div>

    </div>

  </div>

</section>



    </>
  );
}

export default Hero;